<template>
  <AdminDeviceFormPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminDeviceFormPage from "shared-ui/pages/AdminDeviceFormPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_add_device.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
